import React from 'react';
import { SvgIcon } from '@material-ui/core';

const MarketIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/market.svg" alt="" />
  );
};

export default MarketIcon;
